// @ts-check

// Module stichting-crow/table-helper
export const name = "stichting-crow/table-helper";

const keyword2class = {
  NOTE: { node: "aside", classes: ["note"] },
  EDNOTE: { node: "div", classes: ["ednote"] },
  EXAMPLE: { node: "aside", classes: ["example"] },
  ILLEGAL: { node: "aside", classes: ["example", "illegal-example"] },
  ISSUE: { node: "aside", classes: ["issue"] },
  ADVISEMENT: { node: "aside", classes: ["advisement"] },
  DEF: { node: "div", classes: ["def"] },
};
const typeNumberTitleRegex =
  /^(NOTE|EXAMPLE|ILLEGAL|ISSUE|ADVISEMENT|DEF|EDNOTE)(?:\s+#(\d+))?(?:\s+"([^\r\n\t\f\v]+)")?/;

/**
 * Change Markdown block quotes to <div>s as a NOTE, EXAMPLE, ISSUE, ADVISEMENT.
 *
 * Only top-level (i.e. section-level) blockquotes are supported.
 *
 * Syntax:
 *  #NUMBER - Refers to a GitHub issue with number NUMBER. Only supported for ISSUE blocks.
 *  "CAPTION" - Caption to the block, like title on a NOTE, EXAMPLE, etc.
 *
 * @param {Conf} conf
 */
export function run(conf) {
  const quotes = document.querySelectorAll("section > blockquote");
  quotes.forEach(quote => {
    const textContent = quote.textContent.trim();

    // The first words needs to be a keyword
    const keywordResults = typeNumberTitleRegex.exec(textContent);
    if (!keywordResults) return;
    let [src, type, number_, title] = keywordResults;

    // create replacer node
    const formatdesc = keyword2class[type];
    /** @type {HTMLDivElement} */
    const elem = document.createElement(formatdesc.node);
    elem.classList.add(...formatdesc.classes);

    if (number_) {
      // early return: retrieve title and contents from GitHub
      elem.dataset["number"] = number_;
      quote.parentNode.replaceChild(elem, quote);
      return;
    }

    if (title) elem.title = title;

    // Remove TYPE "Title" markup and copy to new element
    elem.innerHTML = quote.innerHTML.replace(src, "");
    quote.parentNode.replaceChild(elem, quote);
  });
}
